export const SignaturePerson = Object.freeze({
  COLABORADOR: "COLABORADOR",
  NOTIFICADOR: "NOTIFICADOR",
  CARGO: "CARGO",
  CARGO_Y_SEDE: "CARGO_Y_SEDE",
  JEFE_INMEDIATO: "JEFE_INMEDIATO",
  JEFE_GESTION_HUMANA: "JEFE_GESTION_HUMANA",
  USUARIO_ADMINISTRADOR: "USUARIO_ADMINISTRADOR",
  RESPONSABLE_PERSONALIZADO:"RESPONSABLE_PERSONALIZADO"
});
